import React from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  hover?: boolean;
  padding?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  className?: string;
}

const Card: React.FC<CardProps> = ({
  children,
  header,
  footer,
  hover = false,
  padding = '1.5rem',
  style,
  onClick,
}) => {
  return (
    <motion.div
      whileHover={hover ? { y: -2, boxShadow: '0 8px 25px rgba(0,0,0,0.08)' } : {}}
      onClick={onClick}
      style={{
        background: 'var(--color-surface)',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'var(--shadow-sm)',
        border: '1px solid var(--color-border-light)',
        overflow: 'hidden',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all var(--transition-base)',
        ...style,
      }}
    >
      {header && (
        <div
          style={{
            padding: '1rem 1.5rem',
            borderBottom: '1px solid var(--color-border-light)',
            fontWeight: 600,
            fontSize: 'var(--font-size-base)',
          }}
        >
          {header}
        </div>
      )}
      <div style={{ padding }}>{children}</div>
      {footer && (
        <div
          style={{
            padding: '0.75rem 1.5rem',
            borderTop: '1px solid var(--color-border-light)',
            background: 'var(--color-bg)',
          }}
        >
          {footer}
        </div>
      )}
    </motion.div>
  );
};

export default Card;
